import { Component, Input, OnInit } from "@angular/core";
import { FlujoVentaPaso } from "../../../_models/flujo-venta-paso";
import { TabViewCustom } from "../../../_models/tab-view-custom";
import { SelectItem } from "primeng/api";
@Component({
  selector: "app-flujo-venta-politicas",
  templateUrl: "./flujo-venta-politicas.component.html",
  styleUrls: ["./flujo-venta-politicas.component.css"],
})
export class FlujoVentaPoliticasComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() titulo: string;

  tabSeleccionado = "DATGEN";

  constructor() {}

  ngOnInit() {}

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
      case 3: {
        this.tabSeleccionado = "POLICONFIG";
        break;
      }
    }
  }
}
